import { Component, Input, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { QuotaSupplierTypeLimit } from '../../../services/dashboard.interface';

@Component({
  selector: 'app-supplier-type-limits-compare',
  imports: [CommonModule, MatCardModule, TranslateModule],
  templateUrl: './supplier-type-limits-compare.html',
  styleUrl: './supplier-type-limits-compare.css',
})
export class SupplierTypeLimitsCompareComponent {
  @Input() set quotaHistoricalSupplierTypeLimit(value: QuotaSupplierTypeLimit | null | undefined) {
    this._historicalLimit.set(value ?? null);
  }
  @Input() set quotaNewSupplierTypeLimit(value: QuotaSupplierTypeLimit | null | undefined) {
    this._newLimit.set(value ?? null);
  }

  private _historicalLimit = signal<QuotaSupplierTypeLimit | null>(null);
  private _newLimit = signal<QuotaSupplierTypeLimit | null>(null);

  stats = computed(() => {
    const historical = this._historicalLimit();
    const newSupplier = this._newLimit();

    const historicalValue = historical?.deliveredVolume ?? 0;
    const newValue = newSupplier?.deliveredVolume ?? 0;

    const isAllZero = historicalValue === 0 && newValue === 0;

    const rawMax = Math.max(historicalValue, newValue, 1);
    const maxScale = isAllZero ? 10 : Math.ceil(rawMax / 100) * 100;

    const historicalPct = isAllZero ? 0 : (historicalValue / maxScale) * 100;
    const newPct = isAllZero ? 0 : (newValue / maxScale) * 100;

    // Шкала: либо 0..10, либо 11 делений от 0 до maxScale
    const scaleSteps = isAllZero
      ? Array.from({ length: 6 }, (_, i) => i * 2) // 0,2,4,6,8,10
      : Array.from({ length: 11 }, (_, i) => Math.round((maxScale / 10) * i));

    return {
      historicalValue,
      newValue,
      historicalPct,
      newPct,
      maxScale,
      scaleSteps,
      isAllZero
    };
  });

  getScaleStepPosition(index: number): number {
    const steps = this.stats().scaleSteps;
    return (index / (steps.length - 1)) * 100;
  }
}
